import api from './api'

const API = '/api/invoices'

export const Invoice = {
  get: function(params) {
    return api.get(API, params)
  },
  show: function(id, params) {
    return api.get(API + '/' + id, params)
  },
  downloadPdf: function(id, params) {
    return api.create(API + '/' + id + '/download-pdf', params)
  },
  autoGenerate: function(params) {
    return api.create(API + '/auto-generate', params)
  },
  create: function(params) {
    return api.create(API, params)
  },
  final: function(params) {
    return api.update(API+'/'+params.id+'/final', params)
  },
  update: function(params) {
    return api.update(API+'/'+params.id, params)
  },
  delete: function(params) {
    return api.delete(API+'/'+params.id, params)
  }
}
